<template>
    <div class="member">
        <el-form :model="migrationForm" status-icon ref="form" label-width="110px" label-position="left" class="demo-migrationForm">
            <div v-for="(item, index) in migrationForm.migrationList" :key="index">
                <h1>迁徙{{ index + 1 }}</h1>
                <el-form-item label="迁徙时间">
                    <date
                        :propssr="item.riqi"
                        :propsnlsr="item.nlriqi"
                        :propscd="item.cd"
                        :propsnh="item.nh"
                        :propssdlr="item.sdlr"
                        :propsgynf="item.gynf"
                        :propscdday="item.cdday"
                        :propscdmonth="item.cdmonth"
                        :propssrlx="item.rqlx"
                        propskey=""
                        propskeyType="migrationList"
                        :propskeyInd="index"
                        @dateFun="dateFun"
                    ></date>
                </el-form-item>
                <!-- <el-form-item label="手工填写">
                    <el-input v-model="item.fqxm" placeholder="父亲姓名" style="width:625px"></el-input>
                </el-form-item> -->
                <el-form-item label="迁徙原因">
                    <el-input v-model="item.qxyy" placeholder="迁徙原因" style="width:625px"></el-input>
                </el-form-item>
                <el-form-item label="迁出地">
                    <Area
                        :propsinorout="item.qcinorout || 1"
                        :propssheng="item.qcsheng"
                        :propsshi="item.qcshi"
                        :propsxian="item.qcxian"
                        :propszhen="item.qczhen"
                        :propsdizhi="item.qcdizhi"
                        :propsdtdz="item.qcdtdz"
                        :propskey="'qc'"
                        :propskeyType="'migrationList'"
                        :propskeyInd="index"
                        :propsdwShow="true"
                        @area="area"
                    ></Area>
                    <a
                        href="javascript:;"
                        @click="sameCsd(index)"
                        style="position: absolute; left: 560px; top: 10px;line-height:20px; color: #409EFF;"
                        >同出生地</a
                    >
                </el-form-item>
                <!-- <el-input v-model="item.qcdtdz" placeholder="" style="width:625px"></el-input> -->
                <!-- <el-form-item label="迁出定位">
                    <el-input
                        v-model="item.qcdtdz"
                        placeholder="点击定位"
                        @focus="mapOpen('qcdtdz', 'migrationList', index)"
                        style="width:625px; cursor: pointer;"
                    >
                    </el-input>
                </el-form-item> -->
                <el-form-item label="迁入地">
                    <Area
                        :propsinorout="item.qrinorout || 1"
                        :propssheng="item.qrsheng"
                        :propsshi="item.qrshi"
                        :propsxian="item.qrxian"
                        :propszhen="item.qrzhen"
                        :propsdizhi="item.qrdizhi"
                        :propsdtdz="item.qrdtdz"
                        :propskey="'qr'"
                        :propskeyType="'migrationList'"
                        :propskeyInd="index"
                        :propsdwShow="true"
                        @area="area"
                    ></Area>
                </el-form-item>
                <!-- <el-input v-model="item.qrdtdz" placeholder="迁入定位" style="width:625px"></el-input> -->
                <!-- <el-form-item label="迁入定位">
                    <el-input
                        v-model="item.qrdtdz"
                        placeholder="点击定位"
                        @focus="mapOpen('qrdtdz', 'migrationList', index)"
                        style="width:625px; cursor: pointer;"
                    >
                    </el-input>
                </el-form-item> -->
                <a href="javascript:;" @click="delSpouse(index)">删除迁徙</a>
            </div>
        </el-form>
        <a href="javascript:;" @click="addSpouse()">添加迁徙</a>

        <el-dialog :visible.sync="dialogMap" width="500" append-to-body class="map">
            <vmap @getLnglat="getPosi" :data="dtdzMap"></vmap>
        </el-dialog>
    </div>
</template>
<script>
import api from "@/request/api";
import vmap from "@/components/vmap.vue";
import Area from "@/components/area.vue";
import date from "@/components/date.vue";

export default {
    props: ["data"],
    data() {
        return {
            dialogMap: false,
            dtdzMap: [],
            timeType: "公历",
            time: "",
            zydata: [],
            zxjbData: [],
            migrationForm: {
                migrationList: []
            },
            type: "",
            formKey: "",
            mdelData: []
        };
    },
    created() {
        // this.migrationForm.migrationList = this.data;
        if (this.data.length != 0) {
            this.$set(this.migrationForm, "migrationList", this.data);
        }
    },
    mounted() {},
    methods: {
        getList() {
            // api.migrationList(localStorage.getItem("fid")).then((res) => {
            // this.tableData = res.data;
            // });
        },
        // 添加配偶
        addSpouse() {
            let data = this.$utils.mData();
            data.isAdd = 1;
            this.migrationForm.migrationList.push(data);
        },
        delSpouse(ind) {
            let id = this.migrationForm.migrationList[ind].id;
            if (id) {
                this.mdelData.push({ id: id, isdel: 1 });
            }
            if (this.migrationForm.migrationList.length > 1) {
                this.migrationForm.migrationList.splice(ind,1);
                // this.migrationForm.migrationList.pop();
            }
        },
        // 时间
        dateFun(data, key) {
            this.$set(this.migrationForm.migrationList[data.keyInd], "riqi", data.sr);
            this.$set(this.migrationForm.migrationList[data.keyInd], "nlriqi", data.nlsr);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "cd", data.cd);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "nh", data.nh);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "sdlr", data.sdlr);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "gynf", data.gynf);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "cdday", data.day);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "cdmonth", data.month);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "rqlx", data.srlx);
        },
        //地图定位
        mapOpen(key, type, index) {
            this.mapType = type;
            this.mapIndex = index;
            this.maKkey = key;
            if (this.mapType == "migrationList") {
                this.dtdzMap = this.migrationForm.migrationList[index][key];
            } else {
                this.dtdzMap = this.migrationForm[key];
            }
            this.dialogMap = true;
        },
        getPosi(lng, lat, address) {
            this.dialogMap = false;
            if (this.mapType == "migrationForm") {
                this.$set(this.migrationForm, this.maKkey, lng + ", " + lat);
            } else if (this.mapType == "migrationList") {
                this.$set(this.migrationForm.migrationList[this.mapIndex], this.maKkey, lng + ", " + lat);
            } else {
                this.$set(this.migrationForm, this.maKkey, lng + ", " + lat);
            }
        },
        // 地址
        area(data) {
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "inorout", data.inorout);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "sheng", data.sheng);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "shi", data.shi);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "xian", data.xian);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "zhen", data.zhen);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "dizhi", data.dizhi);
            this.$set(this.migrationForm.migrationList[data.keyInd], data.key + "dtdz", data.dtdz);
        },
        sameCsd(index) {
            this.$set(this.migrationForm.migrationList[index], "qcinorout", this.$parent.$parent.$parent.ruleForm.inorout);
            this.$set(this.migrationForm.migrationList[index], "qcsheng", this.$parent.$parent.$parent.ruleForm.sheng);
            this.$set(this.migrationForm.migrationList[index], "qcshi", this.$parent.$parent.$parent.ruleForm.shi);
            this.$set(this.migrationForm.migrationList[index], "qcxian", this.$parent.$parent.$parent.ruleForm.xian);
            this.$set(this.migrationForm.migrationList[index], "qczhen", this.$parent.$parent.$parent.ruleForm.zhen);
            this.$set(this.migrationForm.migrationList[index], "qcdizhi", this.$parent.$parent.$parent.ruleForm.zdydz);
        }
    },
    components: {
        vmap,
        Area,
        date
        // orgtree
    },
    watch: {
        data: function(newVal, oldVal) {
            newVal;
            if (newVal.length != 0) {
                this.$set(this.migrationForm, "migrationList", newVal);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.member {
    overflow: hidden;
    height: 100%;

    .el-dialog__body {
        max-height: 410px;
        overflow: auto;
    }
    .chart {
        width: 100%;
        height: 100%;
        overflow: auto;
        text-align: center;

        .org-tree-container {
            background-color: #f2eee4;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/info/migrationForm.vue